import { render } from "./DrawPointsUpgradeView.vue?vue&type=template&id=2e22f743&scoped=true"
import script from "./DrawPointsUpgradeView.vue?vue&type=script&lang=js"
export * from "./DrawPointsUpgradeView.vue?vue&type=script&lang=js"

import "./DrawPointsUpgradeView.vue?vue&type=style&index=0&id=2e22f743&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e22f743"],['__file',"DrawPointsUpgradeView.vue"]])

export default __exports__